import axios from "axios";
import { API_URL, LOGINAPP_API_URL, APP_ID } from "configs";
import { showSuccessModal } from 'actions';


export const USERS_ROLE_REQUEST = "USERS_ROLE_REQUEST";
export const USERS_ROLE_SUCCESS = "USERS_ROLE_SUCCESS";
export const USERS_LIST_SUCCESS = "USERS_LIST_SUCCESS";
export const USERS_ROLE_VALIDATION_ERROR = "USERS_ROLE_VALIDATION_ERROR";
const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_USERS_ROLE_FEILD_VALIDATION_ERROR =
  "HIDE_USERS_ROLE_FEILD_VALIDATION_ERROR";
export const REDIRECT_TO_USERS_ROLE_LIST = "REDIRECT_TO_USERS_ROLE_LIST";
export const USERS_ROLE_GET_SUCCESS = "USERS_ROLE_GET_SUCCESS";




const SHOW_LOADER = "SHOW_LOADER";
const HIDE_LOADER = "HIDE_LOADER";

const showCommonLoader = (label = "") => ({
  type: SHOW_LOADER,
  common_loder_label: label,
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
});

const usersRoleRequest = () => ({
  type: USERS_ROLE_REQUEST,
});

const usersListSuccess = (usersListFetch) => ({
  type: USERS_LIST_SUCCESS,
  usersListFetch: usersListFetch,
});

const usersFailure = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "general_error",
});
const validationError = (notification) => ({
  type: USERS_ROLE_VALIDATION_ERROR,
  validation_error: notification,
});
const tokenError = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "token_expire",
});

const usersRoleAddUpdateSuccess = (message, action, dispatch) => {
  dispatch(usersSuccessNotification(message));
  dispatch(redirectToUsersRoleList());
  dispatch(gypsyballusersListFetch()); // Refetch the user list
};

export const redirectToUsersRoleList = () => ({
  type: REDIRECT_TO_USERS_ROLE_LIST,
});

const getUsersSuccess = (response, action) => ({
  type: USERS_ROLE_GET_SUCCESS,
  record: response,
  actionType: action,
});

const usersSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});

export const hideUsersRoleValidationError = (feild_key) => ({
  type: HIDE_USERS_ROLE_FEILD_VALIDATION_ERROR,
  feild_key: feild_key,
});

export const gypsyballusersListFetch = (app_id = APP_ID) => {
  console.log("app_id in action", app_id);
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(usersRoleRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "user_roles/getAppUser/" + app_id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(usersListSuccess(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const addUserRoles = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(usersRoleRequest());
    return axios(API_URL + "user_roles/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
           dispatch(showSuccessModal(`User Role Updated Successfully`));
      },
      (error) => {
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

// export const updateUsers = (data) => {
//   var token  = localStorage.getItem("token")
//   return dispatch => {
//     dispatch(usersRoleRequest())
//     return axios(API_URL+"user_roles/update/"+data.id, {
//       method: "PUT",
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//         'Authorization':'Bearer  '+token
//       },
//       data: data
//     })
//     .then((response) => {
//       usersRoleAddUpdateSuccess('User Updated Successfully','update',dispatch)
//     }, (error) => {
//       handleErrorResponse(error,dispatch)
//     });

//   }
// }

// export const getUsersById = (id,action) => {
//   var token  = localStorage.getItem("token")
//   return dispatch => {
//     dispatch(usersRoleRequest())
//     return axios(API_URL+"user_roles/getById/"+id, {
//       method: "GET",
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//         'Authorization':'Bearer  '+token
//       },
//     })
//     .then((response) => {
//       dispatch(getUsersSuccess(response.data,action))
//     }, (error) => {
//       handleErrorResponse(error,dispatch)
//     });

//   }
// }

// export const deleteUsers = (usersId, object_viewed_id) => {
//   var token  = localStorage.getItem("token")
//   return dispatch => {
//     dispatch(usersRoleRequest())
//       return axios(API_URL+"user_roles/delete/"+usersId, {
//         method: "DELETE",
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json',
//           'Authorization':'Bearer '+token
//         },
//         data:{
//           object_viewed_id
//         }
//       })
//       .then((response) => {
//           dispatch(usersSuccessNotification('User deleted successfully'))
//       }, (error) => {
//         handleErrorResponse(error,dispatch)
//       });
//     }

// }

// handling error reponse
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = "";
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(usersFailure(err));
    }
  } catch (e) {
    dispatch(usersFailure("Unable to perform action.Something went wrong"));
  }
};
